import React, { lazy, Suspense } from 'react';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';

// Importation des routes de redirection
import Loader from 'src/presentation/modules/redirect/loader/loaderPage';

// importation des composants
import ConnectionStatus from 'src/presentation/components/connexionStatus/connectionStatus';

// Importaion des securisation des routes
import ProtectedRoute from 'src/infra/security/protectedRoutes';
import { Toaster } from 'sonner';

// Page lobale
const Layout = lazy(() => import('src/presentation/modules'));

// Route principal par section de page
const SofiaRoutes = lazy(() => import('./sofia'));

// Importaion des pages de redirection
const NotFound = lazy(
    () => import('src/presentation/modules/redirect/notFound/notFound'),
);

const RedirectionRoutes = lazy(() => import('./redirect'));

/**
 *
 * @desc: Configuration global des routes
 */
const RoutesConfig = () => {
    return (
        <BrowserRouter>
            <Suspense fallback={<Loader />}>
                {/* Constant components */}
                <ConnectionStatus />
                <Toaster
                    position="top-center"
                    expand={false}
                    richColors
                    closeButton
                />

                <Routes>
                    {/* Rediriger de '/' vers '/auth' */}
                    <Route
                        path="/"
                        element={<Navigate to="/sofia" replace />}
                    />

                    <Route path="/" element={<Layout />}>
                        {/* Sous-routes pour Auth */}
                        <Route path="sofia/*" element={<SofiaRoutes />} />

                        {/* Sous-routes pour les redirections */}
                        <Route
                            path="redirect/*"
                            element={<RedirectionRoutes />}
                        />
                        {/* Routes des pages introuvable*/}
                        <Route path="*" element={<NotFound />} />
                    </Route>
                </Routes>
            </Suspense>
        </BrowserRouter>
    );
};

export default RoutesConfig;
